import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { ExplorerCatalogKey } from './explorer.i18n.js';
import { EXPLORER_CATALOG } from './explorer.i18n.js';

export type ExplorerMessageId = `explorer:${ExplorerCatalogKey}`;

const PREFIX_LENGTH = 'explorer:'.length;

/** `t()` for the stop-gap `explorer:` scope (see `explorer.i18n.ts`). */
export function useExplorerT(): { t: (id: ExplorerMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: ExplorerMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as ExplorerCatalogKey;
      const raw = EXPLORER_CATALOG[locale][key] ?? EXPLORER_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
